import { useState } from 'react';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import {
  listNotificationMeetings,
  type NotificationMeeting,
  type NotificationRecipient,
} from '@/lib/notificationSend.ts';

export interface MeetingChoiceState {
  meetings: UseQueryResult<NotificationMeeting[]>;
  meetingId: string;
  selectedMeeting: NotificationMeeting | undefined;
  choose: (meetingId: string) => void;
  clear: () => void;
}

/** The meeting a meeting moment is about, out of the recipient's recent and coming ones. */
export function useMeetingChoice(
  recipient: NotificationRecipient | null,
): MeetingChoiceState {
  const [meetingId, setMeetingId] = useState('');

  const meetings = useQuery({
    queryKey: ['notificationMeetings', recipient?.user_id],
    queryFn: () => listNotificationMeetings(recipient!.user_id),
    enabled: recipient !== null,
  });

  return {
    meetings,
    meetingId,
    selectedMeeting: (meetings.data ?? []).find((meeting) => meeting.id === meetingId),
    choose: setMeetingId,
    clear: () => setMeetingId(''),
  };
}
